import { DealObject } from '../params/pipeline';
import { MetaObject } from '../params/prospect';

export const generateProspectResultMeta = (deal: DealObject): MetaObject[] => {
    return [
        {
            id: 1,
            prospect_result_id: 1,
            meta_key: 'phone',
            meta_value: deal?.phone,
            created_at: '',
            updated_at: ''
        },
        {
            id: 2,
            prospect_result_id: 2,
            meta_key: 'email',
            meta_value: deal?.email,
            created_at: '',
            updated_at: ''
        },
        {
            id: 3,
            prospect_result_id: 3,
            meta_key: 'address1',
            meta_value: deal.address || '',
            created_at: '',
            updated_at: ''
        }
    ];
};